export default __webpack_public_path__ + "static/media/export.7fa18e76.svg";